module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticClass: "gs-menu"
  }, [_c('el-menu', {
    attrs: {
      "background-color": "#324057",
      "text-color": "#fff",
      "active-text-color": "#FACE68",
      "default-active": _vm.active,
      "mode": "horizontal",
      "router": ""
    }
  }, [_c('el-menu-item', {
    staticClass: "gs-logo gs-border-none",
    attrs: {
      "index": "dashboard",
      "route": {
        name: 'dashboard'
      }
    }
  }, [_vm._v("ONX\n          CMS")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "price-table",
      "route": {
        name: 'price-table'
      }
    }
  }, [_vm._v("Bảng giá")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "promotions",
      "route": {
        name: 'promotion'
      }
    }
  }, [_vm._v("Mã giảm giá")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "blocks",
      "route": {
        name: 'blocks'
      }
    }
  }, [_vm._v("Chặn tuyến đường")]), _vm._v(" "), _c('el-submenu', {
    attrs: {
      "index": "services-group"
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_vm._v("Dịch vụ")])]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "services",
      "route": {
        name: 'services'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-list-alt"
  }), _vm._v(" Dịch vụ\n          ")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "check-ghn-service",
      "route": {
        name: 'check-ghn-service'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-check"
  }), _vm._v(" CheckGHNService\n          ")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "bank",
      "route": {
        name: 'bank'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-university"
  }), _vm._v(" Ngân hàng\n          ")])], 2), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "carriers",
      "route": {
        name: 'carrier'
      }
    }
  }, [_vm._v("Hãng vận chuyển")]), _vm._v(" "), _c('el-submenu', {
    attrs: {
      "index": "locations-group"
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_vm._v("Địa điểm")])]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "regions",
      "route": {
        name: 'region'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-map-marker",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Vùng miền\n          ")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "cities",
      "route": {
        name: 'city'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-map-marker",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Tỉnh thành\n          ")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "districts",
      "route": {
        name: 'district'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-map-marker",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Quận huyện\n          ")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "wards",
      "route": {
        name: 'ward'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-map-marker",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Phường xã\n          ")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "addresses",
      "route": {
        name: 'address'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-map-marker",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Địa chỉ\n          ")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "post-offices",
      "route": {
        name: 'post-offices'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-location-arrow",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Bưu cục\n          ")])], 2), _vm._v(" "), _c('el-submenu', {
    attrs: {
      "index": "news-group"
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_vm._v("Tin tức")])]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "blogs",
      "route": {
        name: 'blog'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-rss",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Bài viết\n          ")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "categories",
      "route": {
        name: 'category'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-th-list",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Danh mục\n          ")])], 2), _vm._v(" "), _c('div', {
    staticClass: "header-right gs-border-none pull-right padding-right padding-left"
  }, [_c('el-dropdown', [_c('span', {
    staticClass: "el-dropdown-link"
  }, [_c('i', {
    staticClass: "el-icon-setting icon-header"
  })]), _vm._v(" "), _c('el-dropdown-menu', {
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [_c('el-dropdown-item', [_c('a', {
    staticClass: "text-blue",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.logOut()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-sign-out",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Đăng\n                  xuất")])]), _vm._v(" "), _c('el-dropdown-item', [_c('a', {
    staticClass: "text-blue",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.changePassword()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-key",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n                  Đổi mật\n                  khẩu")])]), _vm._v(" "), _c('el-dropdown-item', [_c('a', {
    staticClass: "text-blue text-remove-decoration",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.$router.push({
          name: 'setting'
        })
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-cogs"
  }), _vm._v(" Cấu hình cài đặt\n                ")])])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "header-right gs-border-none pull-right padding-right padding-left"
  }, [_c('el-popover', {
    ref: "popover",
    attrs: {
      "width": "200",
      "trigger": "hover"
    }
  }, [_c('h3', {
    staticClass: "text-center text-blue remove-margin"
  }, [_vm._v("Thông tin tài khoản")]), _vm._v(" "), _c('p', [_c('i', {
    staticClass: "fa fa-user"
  }), _vm._v(" " + _vm._s(_vm.accountInfo.name))]), _vm._v(" "), _c('p', [_c('i', {
    staticClass: "fa fa-phone"
  }), _vm._v(" " + _vm._s(_vm.accountInfo.phone))]), _vm._v(" "), _c('p', [_c('i', {
    staticClass: "fa fa-envelope-o"
  }), _vm._v(" " + _vm._s(_vm.accountInfo.email))])]), _vm._v(" "), _c('i', {
    directives: [{
      name: "popover",
      rawName: "v-popover:popover",
      arg: "popover"
    }],
    staticClass: "fa fa-user-circle-o icon-header"
  })], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Đổi mật khẩu",
      "visible": _vm.changePasswordModal
    },
    on: {
      "update:visible": function($event) {
        _vm.changePasswordModal = $event
      }
    }
  }, [_c('el-form', {
    ref: "changePasswordForm",
    attrs: {
      "rules": _vm.rules,
      "model": _vm.account,
      "label-width": "120px",
      "label-position": "top"
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.validateBeforeSubmit.apply(null, arguments)
      }
    }
  }, [_c('el-form-item', {
    staticClass: "padding-login-item",
    attrs: {
      "label": "Mật khẩu hiện tại",
      "prop": "old_password"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "placeholder": "Mật khẩu hiện tại"
    },
    model: {
      value: (_vm.account.old_password),
      callback: function($$v) {
        _vm.$set(_vm.account, "old_password", $$v)
      },
      expression: "account.old_password"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "padding-login-item",
    attrs: {
      "label": "Mật khẩu mới",
      "prop": "password"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "placeholder": "Mật khẩu mới"
    },
    model: {
      value: (_vm.account.password),
      callback: function($$v) {
        _vm.$set(_vm.account, "password", $$v)
      },
      expression: "account.password"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Nhập lại mật khẩu",
      "prop": "password_confirmation"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "placeholder": "Nhập lại mật khẩu"
    },
    model: {
      value: (_vm.account.password_confirmation),
      callback: function($$v) {
        _vm.$set(_vm.account, "password_confirmation", $$v)
      },
      expression: "account.password_confirmation"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "padding-login-item"
  }, [_c('el-button', {
    staticClass: "width-100",
    attrs: {
      "type": "primary",
      "native-type": "submit"
    }
  }, [_c('i', {
    staticClass: "fa fa-floppy-o"
  }), _vm._v(" Lưu\n              lại")])], 1)], 1)], 1)], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-4f3bfd5b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/app/GsMenu.vue
// module id = 706
// module chunks = 1